import { Injectable } from '@angular/core';

import { Classification } from '../../../model/attr/classification';
import { DataOperationUtil } from '../../../service/util/data-operation.util';
import { NecMultiSelectData } from '../../selects/multi-select/multi-select-data';

@Injectable()
export class NecClassificationSelectService {
  constructor() {
  }

  setMultiSelectData(classifications: Classification[] = [], multiSelectData: NecMultiSelectData) {
    multiSelectData.selectItems = [];
    classifications.forEach(classification => {
      multiSelectData.selectItems.push({label: classification.name, value: classification.id});
    });
  }

  getSelectedClassification(classifications: Classification[], ids: number[]): Classification[] {
    classifications = classifications || [];
    return classifications.filter(classification => DataOperationUtil.arrayIncludes(ids, classification.id));
  }

  getSelectedValues(multiSelectData: NecMultiSelectData, classificationIds: number[]): string[] {
    let results = [];
    multiSelectData.selectItems.forEach(selectItem => {
      if (DataOperationUtil.arrayIncludes(classificationIds, selectItem.value)) {
        results.push(selectItem.value);
      }
    });
    return results;
  }
}
